var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanAddFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1457 5.79439C16.1457 3.74483 14.5134 2.08334 12.5 2.08334C12.3662 2.08334 12.2325 2.09084 12.0996 2.10579C10.0983 2.3309 8.65523 4.16481 8.87638 6.20194L9.11164 8.36939C9.30253 10.1277 10.7622 11.4583 12.5 11.4583C14.2378 11.4583 15.6975 10.1277 15.8883 8.36939L16.1236 6.20194C16.1383 6.06662 16.1457 5.93053 16.1457 5.79439Z",
    fill: "#CD6EE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5002 13.0208C7.28803 13.0208 3.646 15.0877 3.646 18.0471V22.9167H15.4652C13.9718 21.6747 13.021 19.8026 13.021 17.7083C13.021 15.9584 13.6849 14.3635 14.7745 13.1617C14.0581 13.0692 13.2975 13.0208 12.5002 13.0208Z",
    fill: "#CD6EE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0002 17.7083C25.0002 20.5848 22.6683 22.9167 19.7918 22.9167C16.9154 22.9167 14.5835 20.5848 14.5835 17.7083C14.5835 14.8319 16.9154 12.5 19.7918 12.5C22.6683 12.5 25.0002 14.8319 25.0002 17.7083ZM19.0106 15.1042V16.9271H17.1877V18.4896H19.0106V20.3125H20.5731V18.4896H22.396V16.9271H20.5731V15.1042H19.0106Z",
    fill: "#CD6EE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanAddFill);
export default __webpack_public_path__ + "static/media/human_add_fill.33d0dab7c9bb522d9d13c6079d821d83.svg";
export { ForwardRef as ReactComponent };